/* ============================================
   AGU BABY V2 — Global JavaScript
   Vanilla JS, zero dependencies
   Mobile-first, spring animations, gestures
   ============================================ */

(function() {
  'use strict';

  /* --- Announcement Bar Rotation (crossfade) --- */
  function initAnnouncementRotation() {
    var messages = document.querySelectorAll('.announcement-message');
    if (messages.length < 2) return;

    var current = 0;
    var speed = 5000;

    // Style all messages for crossfade
    messages.forEach(function(msg) {
      msg.style.position = 'absolute';
      msg.style.left = '0';
      msg.style.right = '0';
      msg.style.transition = 'opacity 0.4s ease, transform 0.4s var(--ease-out-expo, ease)';
    });
    // Make container relative
    var slider = messages[0].parentNode;
    slider.style.position = 'relative';
    slider.style.height = messages[0].offsetHeight + 'px';

    setInterval(function() {
      messages[current].style.opacity = '0';
      messages[current].style.transform = 'translateY(-6px)';
      messages[current].classList.remove('is-active');

      current = (current + 1) % messages.length;

      messages[current].style.opacity = '1';
      messages[current].style.transform = 'translateY(0)';
      messages[current].classList.add('is-active');
    }, speed);
  }

  /* --- Sticky Header: Hide on scroll-down, show on scroll-up (mobile) --- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var lastScroll = 0;
    var hideThreshold = 200;
    var ticking = false;

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function() {
        var scrollY = window.scrollY;

        // Add shadow after 50px
        header.classList.toggle('scrolled', scrollY > 50);

        // Mobile: hide/show on scroll direction
        if (window.innerWidth < 1001) {
          if (scrollY > hideThreshold && scrollY > lastScroll) {
            header.style.transform = 'translateY(-100%)';
            header.style.transition = 'transform 0.3s var(--ease-out-expo, ease)';
          } else {
            header.style.transform = 'translateY(0)';
            header.style.transition = 'transform 0.3s var(--ease-spring, ease)';
          }
        } else {
          header.style.transform = '';
        }

        lastScroll = scrollY;
        ticking = false;
      });
    }, { passive: true });
  }

  /* --- Mobile Menu with Swipe-to-Close --- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-menu]');
    var close = document.querySelector('[data-mobile-menu-close]');
    var overlay = document.querySelector('[data-mobile-menu-overlay]');

    if (!toggle || !drawer) return;

    var startX = 0;
    var currentX = 0;
    var isDragging = false;

    function openMenu() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      drawer.style.transform = '';
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.style.opacity = '';
      }
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Swipe-to-close gesture
    drawer.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      isDragging = true;
      drawer.style.transition = 'none';
    }, { passive: true });

    drawer.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      var delta = currentX - startX;

      if (delta < 0) { // Swiping left (toward close)
        drawer.style.transform = 'translateX(' + delta + 'px)';
        if (overlay) {
          overlay.style.opacity = Math.max(0, 1 + delta / 300);
        }
      }
    }, { passive: true });

    drawer.addEventListener('touchend', function() {
      if (!isDragging) return;
      isDragging = false;
      drawer.style.transition = '';

      var delta = currentX - startX;
      if (delta < -60) {
        closeMenu();
      } else {
        drawer.style.transform = '';
        if (overlay) overlay.style.opacity = '';
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /* --- Mobile Bottom Nav: Hide on scroll-down --- */
  function initBottomNav() {
    var nav = document.querySelector('[data-bottom-nav]');
    if (!nav) return;

    var lastScroll = 0;
    var ticking = false;

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function() {
        var scrollY = window.scrollY;
        if (scrollY > 300 && scrollY > lastScroll) {
          nav.classList.add('is-hidden');
        } else {
          nav.classList.remove('is-hidden');
        }
        lastScroll = scrollY;
        ticking = false;
      });
    }, { passive: true });
  }

  /* --- Product Page: Image Gallery --- */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-thumb');
    var mainImg = document.getElementById('product-main-img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');

        // Crossfade. Drop srcset/sizes so the new src actually wins —
        // with srcset present the browser ignores src (visible on retina).
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s ease';
        setTimeout(function() {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = thumb.dataset.imageUrl;
          mainImg.style.opacity = '1';
        }, 200);
      });
    });
  }

  /* --- Quantity Buttons --- */
  function initQuantityButtons() {
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentNode.querySelector('input');
        if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentNode.querySelector('input');
        if (input && parseInt(input.value) < 99) input.value = parseInt(input.value) + 1;
      });
    });
  }

  /* --- Variant Selector --- */
  function initVariantSelector() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var selects = form.querySelectorAll('[data-option-select]');
    var variantIdInput = form.querySelector('[data-variant-id]');
    if (!selects.length || !variantIdInput) return;

    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    try {
      var product = JSON.parse(productJson.textContent);
      selects.forEach(function(select) {
        select.addEventListener('change', function() {
          var selectedOptions = Array.from(selects).map(function(s) { return s.value; });
          var variant = product.variants.find(function(v) {
            return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
          });
          if (variant) {
            variantIdInput.value = variant.id;
            var priceEl = form.closest('.product-details')?.querySelector('.product-price');
            if (priceEl) priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
            var addBtn = form.querySelector('.product-add-btn');
            if (addBtn) {
              addBtn.disabled = !variant.available;
              addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
            }
          }
        });
      });
    } catch(e) {}
  }

  /* --- Collection Sort --- */
  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* --- Quick Add to Cart (AJAX + Confetti) --- */
  function initQuickAdd() {
    document.querySelectorAll('.quick-add-btn').forEach(function(btn) {
      var form = btn.closest('form');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'Added!';

          // Confetti burst from button
          if (typeof window.confettiPop === 'function') {
            var rect = btn.getBoundingClientRect();
            window.confettiPop(rect.left + rect.width / 2, rect.top);
          }

          // Update all cart counts with animation
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count, [data-bottom-cart-count]').forEach(function(el) {
                if (typeof window.animateCounter === 'function') {
                  window.animateCounter(el, cart.item_count);
                } else {
                  el.textContent = cart.item_count;
                }
                el.classList.add('bump');
                setTimeout(function() { el.classList.remove('bump'); }, 500);
              });
            });

          setTimeout(function() {
            btn.textContent = 'Quick Add';
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.textContent = 'Quick Add';
            btn.disabled = false;
          }, 1500);
        });
      });
    });
  }

  /* --- Quick Add with variant picker (multi-variant cards) --- */
  function initQuickAddOptions() {
    function bumpCartCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count, [data-bottom-cart-count]').forEach(function(el) {
            if (typeof window.animateCounter === 'function') {
              window.animateCounter(el, cart.item_count);
            } else {
              el.textContent = cart.item_count;
            }
            el.classList.add('bump');
            setTimeout(function() { el.classList.remove('bump'); }, 500);
          });
        });
    }

    document.querySelectorAll('[data-quick-add-wrap]').forEach(function(wrap) {
      var toggle = wrap.querySelector('[data-quick-add-toggle]');
      var options = wrap.querySelector('.quick-add-options');
      if (!toggle || !options) return;

      toggle.addEventListener('click', function() {
        var willOpen = options.hidden;
        // close any other open pickers
        document.querySelectorAll('[data-quick-add-wrap] .quick-add-options').forEach(function(o) {
          o.hidden = true;
        });
        document.querySelectorAll('[data-quick-add-toggle]').forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
        });
        options.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      options.querySelectorAll('[data-qa-variant]').forEach(function(optBtn) {
        optBtn.addEventListener('click', function() {
          optBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: optBtn.dataset.qaVariant, quantity: 1 })
          })
          .then(function(res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function() {
            if (typeof window.confettiPop === 'function') {
              var rect = optBtn.getBoundingClientRect();
              window.confettiPop(rect.left + rect.width / 2, rect.top);
            }
            bumpCartCount();
            toggle.textContent = 'Added!';
            options.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            setTimeout(function() {
              toggle.textContent = 'Quick Add';
              optBtn.disabled = false;
            }, 1500);
          })
          .catch(function() {
            toggle.textContent = 'Error';
            setTimeout(function() {
              toggle.textContent = 'Quick Add';
              optBtn.disabled = false;
            }, 1500);
          });
        });
      });
    });
  }

  /* --- Sticky Add-to-Cart (Product pages) --- */
  function initStickyAddToCart() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var mainBtn = document.querySelector('.product-add-btn, .add-to-cart-btn');
    if (!stickyBar || !mainBtn) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    // Sticky bar add-to-cart action
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        stickyBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: stickyBtn.dataset.variantId,
            quantity: 1
          })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          stickyBtn.textContent = 'Added!';
          if (typeof window.confettiPop === 'function') {
            var rect = stickyBtn.getBoundingClientRect();
            window.confettiPop(rect.left + rect.width / 2, rect.top);
          }
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('.cart-count, [data-bottom-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
              el.classList.add('bump');
              setTimeout(function() { el.classList.remove('bump'); }, 500);
            });
          });
          setTimeout(function() { stickyBtn.textContent = 'Add to Cart'; }, 1500);
        })
        .catch(function() {
          stickyBtn.textContent = 'Error';
          setTimeout(function() { stickyBtn.textContent = 'Add to Cart'; }, 1500);
        });
      });
    }
  }

  /* --- Initialize Everything --- */
  document.addEventListener('DOMContentLoaded', function() {
    // V2 Animation system
    if (typeof window.ScrollAnimator !== 'undefined') {
      window.ScrollAnimator.init();
    }
    if (typeof window.SwipeCarousel !== 'undefined') {
      window.SwipeCarousel.init();
    }
    if (typeof window.ParallaxLite !== 'undefined') {
      window.ParallaxLite.init();
    }

    // Core UI
    initAnnouncementRotation();
    initStickyHeader();
    initMobileMenu();
    initBottomNav();
    initProductGallery();
    initQuantityButtons();
    initVariantSelector();
    initCollectionSort();
    initQuickAdd();
    initQuickAddOptions();
    initStickyAddToCart();
    initSearchOverlay();
  });

  /* --- Search Overlay + Predictive Search --- */
  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    var openBtns = document.querySelectorAll('[data-search-open]');
    var closeBtn = document.querySelector('[data-search-close]');
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (!overlay || !input) return;

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { input.focus(); }, 250);
    }
    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      input.value = '';
      if (results) results.innerHTML = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openOverlay); });
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

    // Click outside the modal content closes
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });

    // Esc closes
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    // Predictive search (debounced)
    var searchTimer = null;
    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (results) results.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function(res) { return res.json(); })
          .then(function(data) {
            if (!results) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              results.innerHTML = '<p style="color:var(--medium-gray);padding:16px 0;text-align:center;">No products found for "' + q + '"</p>';
              return;
            }
            results.innerHTML = products.map(function(p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              var price = p.price ? '$' + (parseFloat(p.price) / 100).toFixed(2) : '';
              return '<a class="search-result-item" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                '<div style="flex:1;min-width:0;">' +
                '<div class="search-result-title">' + p.title + '</div>' +
                (price ? '<div class="search-result-price">' + price + '</div>' : '') +
                '</div></a>';
            }).join('');
          })
          .catch(function() {
            if (results) results.innerHTML = '<p style="color:var(--medium-gray);padding:16px 0;text-align:center;">Search unavailable. Please try again.</p>';
          });
      }, 300);
    });
  }

})();
